package com.example.mystybag.common.ui.views

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.SnackbarData
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.text.style.TextAlign
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.doOnClick
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.composeColor
import com.example.mystybag.core.ui.theme.LocalTheme.p1
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p5
import com.example.mystybag.core.views.AppTheme

@Composable
fun SnackView(data: SnackbarData) {
    val contentColor = AppTheme.current.colors.onSurface
    // Keep visuals close to previous hardcoded values but source from resources/theme.
    val shadowColor  = SR.colors.background_black.composeColor.copy(alpha = 0.6f)
    val borderColor  = AppTheme.current.colors.outline
    val background   = AppTheme.current.colors.surface.copy(alpha = 0.98f)

    Box(modifier = Modifier.fillMaxWidth()) {
        Row(modifier = Modifier
            .padding(start = p32, end = p32)
            .shadow(
                elevation    = p5,
                shape        = RoundedCornerShape(p12),
                ambientColor = shadowColor,
                spotColor    = shadowColor
            )
            .background(background)
            .border(p1, borderColor, RoundedCornerShape(p12))
            .clip(RoundedCornerShape(p12))
            .align(Alignment.Center),
            verticalAlignment     = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            Texts.BodySmall(
                text        = data.visuals.message,
                modifier    = Modifier
                    .wrapContentWidth()
                    .padding(start = p20, end = p20, top = p12, bottom = p12),
                color       = contentColor,
                textAlign   = TextAlign.Center
            )
            data.visuals.actionLabel?.also {
                Texts.TitleSmall(
                    text     = it,
                    color    = AppTheme.current.colors.primary,
                    modifier = Modifier
                        .doOnClick {
                            data.performAction()
                        }
                        .padding(end = p16)
                )
                Image(
                    painter     = painterResource(SRC.images.close_icon),
                    colorFilter = ColorFilter.tint(contentColor),
                    modifier    = Modifier.doOnClick {
                        data.dismiss()
                    }
                )
            }
        }
    }
}

/*
@Preview(showSystemUi = true)
@Composable
fun SnackViewPreview() {
    AppThemePreview {
        SnackView(data = object: SnackbarData {
            override val actionLabel: String? = null
            override val duration: SnackbarDuration = SnackbarDuration.Short
            override val message: String = "Oops, there seems to be an error.\nPlease try again."
            override fun dismiss() {}
            override fun performAction() {}
        })
    }
}*/